var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import xssFilters from 'xss-filters';
import { Tooltip as AntTooltip } from 'antd';
import classNames from 'classnames';
import { StringMode } from './string';

var StringUrlMode = function (_super) {
  __extends(StringUrlMode, _super);

  function StringUrlMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 获取展示组件
   */


  StringUrlMode.prototype.getAvailableDisplayComponent = function (value, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style,
        _a = displayInfo.text,
        text = _a === void 0 ? '[link]' : _a,
        _b = displayInfo.target,
        target = _b === void 0 ? '_blank' : _b;
    value = xssFilters.uriInDoubleQuotedAttr(value);
    return React.createElement(AntTooltip, {
      title: value
    }, React.createElement("a", {
      className: classNames('type-string mode-string-url', className),
      style: style,
      href: value,
      target: target
    }, text));
  };

  return StringUrlMode;
}(StringMode);

export { StringUrlMode };